import { Injectable } from "@angular/core";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { DiscountTypeEnum, InvoiceItem, InvoiceStatus, ItemStateEnum } from "../../model/invoice.model";
import { ItemDependencyType, UnitKindEnum } from "../../model/ItemOrder.model";
import { OrderItem, OrderItemCategory } from "../../model/orderItemcategory.model";
import { OrderService } from "../../order.service";
import { InvoiceService } from "../invoice/invoice.service";
import { InvDailyBalanceInhibitorValueEnum } from "src/app/gnr/branch/branch.enum";
import { BarCodeType, StockInWebKind } from "src/app/frontoffice/catalog/model/item.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class ItemOrderService extends BaseService {
  public _opened: boolean = false;
  public selectedItemCategory: OrderItemCategory = new OrderItemCategory();
  public ItemCategory: OrderItemCategory[];
  public findOrderItem: OrderItem;
  public changeview: boolean;
  public findOrderItemByCode: OrderItem;
  public findOrderItemByBarCodes: OrderItem;

  public itemsList: string[] = [];

  private oldSelectedItemCategory: any;
  constructor(public order: OrderService, public common: CommonService, public invoiceservice: InvoiceService) {
    super();
  }

  async setSelectedItem(item?: OrderItem, qty?: number) {
    item.activeItem = true;
    if (item.Code === 0) {
      this.order.itemHasParent = item.ItemChild;
      return;
    }
    item.UnitKind = UnitKindEnum.NormalItem;
    if (this.order.hasPosScale && this.order.posScaleService.isConnected && !qty) {
      const success = await this.order.posScaleService.getWeight().then((res: number) => {
        if (res > 0) {
          qty = res;
          item.UnitKind = UnitKindEnum.PosScaleItem;
          return true;
        } else if (res < 0) {
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.PosScaleNegative"),
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Warning"),
            DialogType.confirm,
            () => this.setSelectedItem(item, 1)
          );
          return false;
        }
      });
      if (success === false) return;
    }
    const currentBranch = this.order.Branches?.find((x) => x.Id === this.order.invoice.BranchId) || this.order.logInBranch;
    const hasDeposit = this.order.currentInformation?.OrderServices && this.order.saleMethodBranch?.HasDeposit;
    if (!hasDeposit || this.order.invoice?.StatusCode === InvoiceStatus.Ordering) {
      if (item.StockInWeb === StockInWebKind.UnAvailable) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Product")}: ${item.Title} ${this.translate(
            "ClientApp.FrontOffice.Order.OrderPage.Item.NotAvailable"
          )}`,
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.OutOfStock")
        );
        if (currentBranch?.InvDailyBalanceInhibitorId === InvDailyBalanceInhibitorValueEnum.Inhibitor) return false;
      } else if (item.notAvailableGoodIds?.length && item.StockInWeb === StockInWebKind.UnAvailableFromInv) {
        let title = "";
        if (item.notAvailableGoodIds?.length) {
          const goodsStockInfos = this.order.warehouseStockItems?.filter(
            (x) =>
              (x.PrevRemainAmount || x.EntryAmount) &&
              x.BranchId === this.order.invoice.BranchId &&
              item.notAvailableGoodIds.some((goodsId) => x.GoodsId === goodsId)
          );
          if (goodsStockInfos?.length) {
            goodsStockInfos.forEach((info) => {
              title += info.GoodsTitle + " -- ";
            });
          }
        }
        if (title)
          this.sts.showDialog(
            `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Product")}: ${title} ${this.translate(
              "ClientApp.FrontOffice.Order.OrderPage.Item.NotAvailable"
            )}`,
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.OutOfStock")
          );
        if (currentBranch?.InvDailyBalanceInhibitorId === InvDailyBalanceInhibitorValueEnum.Inhibitor) return false;
      } else if (!this.order.isLight) {
        const goodsStockInfo = this.order.warehouseStockItems.find(
          (x) =>
            (x.PrevRemainAmount || x.EntryAmount) &&
            x.BranchId === this.order.invoice.BranchId &&
            (x.ItemsInRelation.some((x) => x.Id === item.Id) || x.GoodsId === item.GoodsId)
        );

        const goodsFormulaQty =
          (goodsStockInfo?.ItemsInRelation?.some((x) => x.Id === item.Id)
            ? goodsStockInfo?.ItemsInRelation?.find((x) => x.Id === item.Id).DecreaseAmount
            : goodsStockInfo?.DecreaseAmount) ?? 0;

        const currentItem = this.order.invoice.Items.find((f) => f.ItemId === item.Id);
        let quantity = 0;

        if (!!this.order.invoice.Id) {
          const oldQuantity = this.order.invoice.OriginalValue?.Items.find((x) => x.Id == item.Id)?.Quantity || 0;
          quantity = ((currentItem?.Quantity || 0) - oldQuantity + (qty ? qty : 1)) * goodsFormulaQty;
        } else {
          quantity = ((currentItem?.Quantity || 0) + (qty ? qty : 1)) * goodsFormulaQty;
        }
        if (this.order.invoice.OriginalValue) {
          let target = this.order.invoice.OriginalValue.Items.find((c) => c.ItemId === item.Id);
          if (target) {
            if (target.Quantity != quantity) this.order.itemQuantityChanged = true;
            else this.order.itemQuantityChanged = false;
          }
        } else this.order.itemQuantityChanged = true;
        if (goodsStockInfo?.Amount < quantity) {
          const notStock = { goodsTitle: goodsStockInfo.GoodsTitle, itemTitle: item.Title, neededAmount: goodsStockInfo?.Amount - quantity };
          const info =
            "(" +
            notStock.goodsTitle +
            " - " +
            notStock.itemTitle +
            " - " +
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Number") +
            " " +
            notStock.neededAmount +
            ")";
          this.sts.showDialog(
            `
            ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.FollowingProductUnavailable")}: <br/>
          
          ${info}
          
          `,
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.OutOfStock")
          );
          if (currentBranch?.InvDailyBalanceInhibitorId === InvDailyBalanceInhibitorValueEnum.Inhibitor) return false;
        }
      }
    }

    this.order.selectedOrderItem = JSON.parse(JSON.stringify(item));
    this.addInvoiceItem(item, qty);
    this.order.SalePriceChange(this.order.invoice.SalePriceTypeId);
    this.order.itemChanged = true;
    this.order.calculate();
    this.order.invoiceChanged = true;
    this.hasDependents(item, qty);
    this.order.focusInput();
    item.activeItem = false;
    this.order.detectChanges();
  }

  public hasDependents(item: OrderItem, qty?: number) {
    let shouldContinue: boolean = true;
    if (item?.Dependents?.length > 0) {
      const saleMethodBranch = this.order.saleMethodBranch;
      if (saleMethodBranch.IncludeItemDependency || saleMethodBranch.IncludeFreeItemDependency) {
        item.Dependents.forEach((dependent) => {
          shouldContinue = true;
          const dependentQty = qty ? dependent.Quantity * qty : dependent.Quantity;
          if (dependent.ItemDependencySaleMethodBranch.length) {
            const hasValidSaleMethodBranch = dependent.ItemDependencySaleMethodBranch.find((e) => e.SaleMethodId === saleMethodBranch.SaleMethodId);
            if (hasValidSaleMethodBranch) {
              dependent.DependentItem.IsDependent = true;
              if (dependent.ItemDependencyTypeCode === ItemDependencyType.Free && saleMethodBranch.IncludeFreeItemDependency) {
                let find_Item = this.order.itemCategoryList[0].Items?.find((i) => i.Id === dependent?.DependentItem?.Id);
                if (!find_Item) {
                  const hasItemChild = this.order.itemCategoryList[0].Items.filter((c) => c.ItemChild && c.ItemChild?.length > 0);
                  hasItemChild.forEach((element) => {
                    if (shouldContinue) {
                      find_Item = element.ItemChild.find((c) => c.Id === dependent?.DependentItem?.Id);
                      if (find_Item) shouldContinue = false;
                    }
                  });
                }
                this.addDependentItem(find_Item, dependentQty, true);
              }
              if (dependent.ItemDependencyTypeCode === ItemDependencyType.Related && saleMethodBranch.IncludeItemDependency) {
                let find_Item = this.order.itemCategoryList[0].Items?.find((i) => i.Id === dependent?.DependentItem?.Id);
                if (!find_Item) {
                  const hasItemChild = this.order.itemCategoryList[0].Items.filter((c) => c.ItemChild && c.ItemChild?.length > 0);
                  hasItemChild.forEach((element) => {
                    if (shouldContinue) {
                      find_Item = element.ItemChild.find((c) => c.Id === dependent?.DependentItem?.Id);
                      if (find_Item) shouldContinue = false;
                    }
                  });
                }
                this.addDependentItem(find_Item, dependentQty, false);
              }
            }
          } else {
            dependent.DependentItem.IsDependent = true;
            let find_Item = this.order.itemCategoryList[0].Items?.find((i) => i.Id === dependent?.DependentItem?.Id);
            if (!find_Item) {
              const hasItemChild = this.order.itemCategoryList[0].Items.filter((c) => c.ItemChild && c.ItemChild?.length > 0);
              hasItemChild.forEach((element) => {
                if (shouldContinue) {
                  find_Item = element.ItemChild.find((c) => c.Id === dependent?.DependentItem?.Id);
                  if (find_Item) shouldContinue = false;
                }
              });
            }
            if (dependent.ItemDependencyTypeCode === ItemDependencyType.Free && saleMethodBranch.IncludeFreeItemDependency) {
              this.addDependentItem(find_Item, dependentQty, true);
            }
            if (dependent.ItemDependencyTypeCode === ItemDependencyType.Related && saleMethodBranch.IncludeItemDependency) {
              this.addDependentItem(find_Item, dependentQty, false);
            }
          }
        });
      }
    }
  }

  addDependentItem(item: OrderItem, qty?: number, isFreeDependent?: boolean) {
    let invoiceItem = new InvoiceItem();
    invoiceItem.IsClubItem = item?.IsClubItem;
    const Items = this.order.invoice.Items;
    let find_Dependent_Item = Items.findIndex((f) => {
      const dependentCondition = isFreeDependent ? f.Price === 0 : f.Price !== 0;
      return (!f.Description || f.Description === "") && f.ItemId === item.Id && dependentCondition;
    });
    let find_Club_Item = Items.some((f) => !f.IsClubItem && f.ItemId === item.Id);

    // dependent item
    if (find_Dependent_Item >= 0 && typeof isFreeDependent == "boolean") {
      if (item.DetaultPrice === 0 && !find_Club_Item && !item.IsClubItem) qty = 1;
      Items[find_Dependent_Item].Quantity += qty;
      invoiceItem = Items[find_Dependent_Item];
      this.order.selectedOrderItemIndex = Items.length - 1;
      item.InvoiceQty = invoiceItem.Quantity;
      invoiceItem.ItemDependencyTypeCode = isFreeDependent ? ItemDependencyType.Free : ItemDependencyType.Related;
      this.order.setValueQuantity();
      this.invoiceservice.setSelectedItem(invoiceItem, invoiceItem.Index);
      return;
    } else {
      this.addItemToInvoiceItems(item, invoiceItem, qty, Items, isFreeDependent);
      this.setValueQuantityAndScrollToItem(Items, item, invoiceItem);
    }
  }

  private setValueQuantityAndScrollToItem(Items: InvoiceItem[], item: OrderItem, invoiceItem: InvoiceItem) {
    this.order.selectedOrderItemIndex = Items.length - 1;
    item.InvoiceQty = invoiceItem.Quantity;
    this.order.setValueQuantity();
    if (item.IsDependent) this.invoiceservice.setItemQuantity(invoiceItem, ItemStateEnum.Increase);
    this.invoiceservice.setSelectedItem(invoiceItem, invoiceItem.Index);

    this.order.detectChanges();
    this.invoiceservice.addRowDiscount();
    if (invoiceItem?.Quantity > 1) this.scrollToItem(invoiceItem);
  }

  public addInvoiceItem(item: OrderItem, qty?: number) {
    //main item
    let invoiceItem = new InvoiceItem();
    invoiceItem.IsClubItem = item?.IsClubItem;
    const Items = this.order.invoice.Items;
    if (this.order.invoice) {
      let find_item_index = Items.findIndex((invoiceItem) => {
        const isNotFreeDependent = invoiceItem.Price !== 0 || item.DetaultPrice === 0;
        return invoiceItem.ItemId === item.Id && isNotFreeDependent && invoiceItem.UnitKind !== UnitKindEnum.PosScaleItem;
      });
      let find_free_Item = Items.findIndex(
        (invoiceItem) => !invoiceItem.Description && invoiceItem.ItemId === item.Id && (invoiceItem.Price !== 0 || item.DetaultPrice === 0)
      );
      if (find_item_index < 0 || item.IsClubItem || find_free_Item < 0) {
        this.addItemToInvoiceItems(item, invoiceItem, qty, Items, false);
      } else {
        if (
          !this.order.HasAccess("PositiveEditOrderingStatus") &&
          !this.order.HasAccess("PositiveEditClearingStatus") &&
          !this.order.HasAccess("PositiveEditClearedStatus") &&
          !this.order.HasAccess("PositiveEditAssignedStatus")
        ) {
          this.sts.showToast(
            "danger",
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.ErrorMessage"),
            this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.AccessToThisArea")
          );
          return;
        }
        if (find_free_Item < 0) {
          Items[find_item_index].Quantity += 1;
          invoiceItem = Items[find_item_index];
        } else {
          if (qty && qty > 0) {
            const quantity = Items[find_free_Item].Quantity + qty;
            Items[find_free_Item].Quantity = +quantity.toFixed(2);
          } else Items[find_free_Item].Quantity += 1;
          invoiceItem = Items[find_free_Item];
        }
      }
    }
    this.setValueQuantityAndScrollToItem(Items, item, invoiceItem);
  }
  addItemToInvoiceItems(item: OrderItem, invoiceItem: InvoiceItem, qty: number, Items: InvoiceItem[], isFreeDependent?: boolean) {
    if (qty && qty > 0) invoiceItem.Quantity = qty;
    else invoiceItem.Quantity = 1;
    invoiceItem.ItemId = item.Id;
    invoiceItem.Ingredients = item.Ingredients;
    invoiceItem.Ingredients_En = item.Ingredients_En;
    invoiceItem.CategoryId = item.CategoryId;
    invoiceItem.ItemTitle = item.Title;
    invoiceItem.UnitKind = item.UnitKind;
    invoiceItem.ApplyService = item.ApplyService ? item.ApplyService : false;
    invoiceItem.ApplyTax = item.ApplyTax ? item.ApplyTax : false;
    invoiceItem.State = RowState.New;
    invoiceItem.GoodsId = item.GoodsId;
    invoiceItem.IsDependent = !!item.IsDependent;
    invoiceItem.Tax = item.Tax;
    invoiceItem.Toll = item.Toll;
    invoiceItem.CookingTime = item.CookingTime;
    invoiceItem.PackingPrice = item.PackingPrice;
    invoiceItem.PrintDisplayOrder = item.PrintDisplayOrder;
    invoiceItem.OrganizationalDiscount = item.OrganizationalDiscount;
    invoiceItem.IsOrganizationalDiscount = item.IsOrganizationalDiscount;
    invoiceItem.Index = Items.length === 0 ? 0 : Items[Items.length - 1].Index + 1;
    this.order.setValue(`RowDiscount${invoiceItem.Index}${this.order.invoice.SaleMethodBranchId}`, null);
    if (isFreeDependent) {
      invoiceItem.UnitPrice = 0;
      invoiceItem.Price = 0;
    } else {
      const findPrice = item.Prices.find((f) => f.SalePriceTypeId === this.order.invoice.SalePriceTypeId);
      if (findPrice) {
        invoiceItem.UnitPrice = findPrice.Price;
        invoiceItem.Price = findPrice.Price;
      } else {
        invoiceItem.UnitPrice = item.Prices.find((f) => f.IsDefault).Price;
        invoiceItem.Price = item.Prices.find((f) => f.IsDefault).Price;
      }
    }
    if (
      !this.order.HasAccess("PositiveEditOrderingStatus") &&
      !this.order.HasAccess("PositiveEditClearingStatus") &&
      !this.order.HasAccess("PositiveEditClearedStatus") &&
      !this.order.HasAccess("PositiveEditAssignedStatus")
    ) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.ErrorMessage"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.AccessToThisArea")
      );
      return;
    }
    Items.push(invoiceItem);
    this.order.detectChanges();
  }

  public changeItemCategory(itemCategory: OrderItemCategory) {
    if (itemCategory.Id !== 0) {
      itemCategory.Items.sort((a, b) => moment(a.CreatedDate).diff(b.CreatedDate, "ms"));
      itemCategory.Items.sort((a, b) => a.Code - b.Code);
    }

    this.order.itemHasParent = null;
    this.order.selectedInvoiceItem = null;
    this.order.selectedOrderItemIndex = null;
    if (this.order.formGroup.controls[`ItemTitle${this.order.__id}`].value && this.oldSelectedItemCategory) {
      this.order.selectedItemCategory = Object.assign({}, this.oldSelectedItemCategory);
    }
    this.order.selectedItemCategory = Object.assign({}, itemCategory);
    this.oldSelectedItemCategory = null;
    if (this.order.formGroup.controls[`ItemTitle${this.order.__id}`].value) {
      this.oldSelectedItemCategory = null;
      this.findItemByName(null);
    }
  }

  /// بر اساس کد
  public findItem(event: string) {
    if (!event || Number(event) <= 0 || isNaN(Number(event))) return;
    const START_INDEX = 0;
    const END_INDEX = 2;
    const fixValue = Number(event?.substring(START_INDEX, END_INDEX));
    const barcodeWithoutFlag = event.slice(0, -1);
    this.findOrderItemByCode = this.order.itemCategoryList[0]?.Items?.find((f) => f.Code === Number(event));
    if (this.findOrderItemByCode) {
      if (this.findOrderItemByCode.StockInWeb > 1) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.Product")}:  ${this.findOrderItemByCode.Title} ${this.translate(
            "ClientApp.FrontOffice.Order.OrderPage.Item.NotAvailable"
          )}`,
          this.translate("ClientApp.FrontOffice.Order.OrderPage.Item.OutOfStock")
        );
      }
      this.order.formGroup.controls[`ItemTitle${this.order.__id}`].setValue(this.findOrderItemByCode.Title);
      this.order.formGroup.controls[`Quantity${this.order.__id}`].setValue(1);
      const inputElement = <HTMLInputElement>document.getElementById(`Quantity${this.order.__id}`)!;
      inputElement.focus();
      setTimeout(() => {
        inputElement.select();
      }, 10);
    } else {
      const findChildItemCategory = this.order.itemCategoryList[0].Items.filter((f) => f.ItemChild && f.ItemChild.length > 0);
      if (findChildItemCategory) {
        for (let index = 0; index < findChildItemCategory.length; index++) {
          this.findOrderItemByCode = findChildItemCategory[index].ItemChild.find((f) => f.Code === Number(event));
          if (this.findOrderItemByCode) {
            this.order.formGroup.controls[`ItemTitle${this.order.__id}`].setValue(this.findOrderItemByCode.Title);
            const inputElement = <HTMLInputElement>document.getElementById(`Quantity${this.order.__id}`);
            inputElement.focus();
            setTimeout(() => {
              inputElement.select();
            }, 10);
            break;
          }
        }
      }
    }
    this.findOrderItemByBarCodes = this.order.itemCategoryList[0]?.Items?.find((f) => f.Barcodes.some((s) => s.Code === event));
    if (!this.findOrderItemByBarCodes) {
      const findChildItemCategory = this.order.itemCategoryList[0].Items.filter((f) => f.ItemChild && f.ItemChild.length > 0);
      if (findChildItemCategory) {
        for (let index = 0; index < findChildItemCategory.length; index++) {
          this.findOrderItemByBarCodes = findChildItemCategory[index].ItemChild.find((f) => f.Barcodes.some((s) => s.Code === event));
          if (this.findOrderItemByBarCodes) {
            this.barcodeFinder(1);
            return;
          }
        }
      }
    }
    const allBarCodesFormat = this.order?.barCodeReaderFormat;
    const barCode = allBarCodesFormat?.find((f) => f?.FixValue === fixValue && f.BarCodeLength === event.length);
    if (barCode) {
      const productCode = Number(barcodeWithoutFlag?.substring(barCode?.CodeStart - 1, barCode?.CodeStart + barCode?.CodeLength - 1));
      this.findOrderItemByBarCodes = this.order.itemCategoryList[0]?.Items?.find((f) => f.Code === productCode);
      if (!this.findOrderItemByBarCodes) {
        const findChildItemCategory = this.order.itemCategoryList[0].Items.filter((f) => f.ItemChild && f.ItemChild.length > 0);
        if (findChildItemCategory) {
          for (let index = 0; index < findChildItemCategory.length; index++) {
            this.findOrderItemByBarCodes = findChildItemCategory[index].ItemChild.find((f) => f.Code === productCode);
            if (this.findOrderItemByBarCodes) {
              break;
            }
          }
        }
      }
      if (this.findOrderItemByBarCodes) {
        const digitCode = Number(barcodeWithoutFlag?.substring(barCode?.DigitStart - 1, barCode?.DigitStart + barCode?.DigitLength - 1));
        const decimalCode = barcodeWithoutFlag?.substring(barCode?.DecimalStart - 1, barCode?.DecimalStart + barCode?.DecimalLength - 1);
        if (
          (barCode?.DigitLength === BarCodeType.WithoutDECIMAL && (!barCode?.DecimalStart || barCode?.DecimalStart === 0)) ||
          (barCode?.DigitLength && (!barCode?.DecimalStart || barCode?.DecimalStart === 0))
        ) {
          this.barcodeFinder(digitCode);
        } else if (barCode?.DigitLength === BarCodeType.WithDECIMAL && barCode?.DecimalStart && barCode?.DigitLength) {
          if (digitCode === 0) {
            this.barcodeFinder(parseFloat(decimalCode) / 1000);
            return;
          } else {
            this.barcodeFinder(digitCode.toString() + "." + decimalCode.toString());
            return;
          }
        }
      }
    } else {
      this.barcodeFinder(1);
      return;
    }
  }

  /// بر اساس نام
  public findItemByName(event: string): void {
    if (this.oldSelectedItemCategory?.Items?.length > 0) this.order.selectedItemCategory = Object.assign({}, this.oldSelectedItemCategory);
    if (this.order.formGroup.controls[`Code${this.order.__id}`].value || !event) {
      if (!event) {
        this.order.setValue(`ItemTitle${this.order.__id}`, "");
      }
      return;
    }

    if (event?.length > 0) {
      if (!this.oldSelectedItemCategory || this.oldSelectedItemCategory?.Items?.length == 0)
        this.oldSelectedItemCategory = Object.assign({}, this.order.selectedItemCategory);
      const tempItemsCategory = Object.assign([], this.order.selectedItemCategory.Items);
      this.order.selectedItemCategory.Items = [];
      tempItemsCategory.forEach((f) => {
        if (f.ItemChild?.length > 0) {
          f.ItemChild.forEach((el) => {
            if (el.Title.includes(event) && !this.order.selectedItemCategory.Items.some((s) => s.Id === el.Id && s.BranchId === el.BranchId)) {
              this.order.selectedItemCategory.Items.push(el);
            }
          });
        } else {
          if (f.Title.includes(event) && !this.order.selectedItemCategory.Items.some((s) => s.Id === f.Id && s.BranchId === f.BranchId)) {
            this.order.selectedItemCategory.Items.push(f);
          }
        }
      });
    } else {
      if (this.oldSelectedItemCategory?.Items?.length > 0) this.order.selectedItemCategory = Object.assign({}, this.oldSelectedItemCategory);
    }
    if (this.order.selectedItemCategory.Items.length > 0) {
      this.order.itemHasParent = null;
    }
  }

  //براساس بارکد پیدا کردن کالا
  public barcodeFinder(event: any) {
    if (this.order.formGroup.controls[`Quantity${this.order.__id}`].valid && event && this.findOrderItemByBarCodes && event > 0) {
      let foundItem = this.findOrderItemByBarCodes;
      this.setSelectedItem(foundItem, Number(event));
      this.findOrderItemByBarCodes = null;
      this.order.formGroup.controls[`Quantity${this.order.__id}`].setValue("");
      this.order.formGroup.controls[`ItemTitle${this.order.__id}`].setValue("");
      this.order.formGroup.controls[`Code${this.order.__id}`].setValue("");
      this.order.focus(`Code${this.order.__id}`);
    }
  }

  public setQuantity(event: any) {
    if (this.order.formGroup.controls[`Quantity${this.order.__id}`].valid && event && this.findOrderItemByCode && event > 0) {
      this.setSelectedItem(this.findOrderItemByCode, event);
      this.findOrderItemByCode = null;
      this.order.formGroup.controls[`Quantity${this.order.__id}`].setValue("");
      this.order.formGroup.controls[`ItemTitle${this.order.__id}`].setValue("");
      this.order.formGroup.controls[`Code${this.order.__id}`].setValue("");
      this.order.focus(`Code${this.order.__id}`);
    }
  }
  changeInvoiceQuantity(item: OrderItem, ItemState: ItemStateEnum) {
    const findInvocieItem = this.order.invoice.Items.find((f) => f.ItemId === item.Id);
    this.invoiceservice.changeQuantity(findInvocieItem, ItemState);
  }
  scrollToItem(invoiceitem: InvoiceItem, isDescription?: boolean) {
    var el = document.getElementById(`factor${this.order.invoice.SaleMethodBranchId}`);
    let item = document.getElementById(invoiceitem.Index.toString());
    if (el && item) this.scrollParentToChild(el, item);
  }
  scrollParentToChild(parent, child) {
    // Where is the parent on page
    var parentRect = parent.getBoundingClientRect();
    // What can you see?
    var parentViewableArea = {
      height: parent.clientHeight,
      width: parent.clientWidth,
    };

    // Where is the child
    var childRect = child.getBoundingClientRect();
    // Is the child viewable?
    var isViewable = childRect.top >= parentRect.top && childRect.bottom <= parentRect.top + parentViewableArea.height;

    // if you can't see the child try to scroll parent
    if (!isViewable) {
      // Should we scroll using top or bottom? Find the smaller ABS adjustment
      const scrollTop = childRect.top - parentRect.top;
      const scrollBot = childRect.bottom - parentRect.bottom;
      if (Math.abs(scrollTop) < Math.abs(scrollBot)) {
        // we're near the top of the list
        parent.scrollTop += scrollTop;
      } else {
        // we're near the bottom of the list
        parent.scrollTop += scrollBot;
      }
    }
  }
}
